var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 605,
    height: 289,
    viewBox: "0 0 605 289",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M293.333 0C254.812 -4.59359e-07 216.668 7.58729 181.08 22.3287C145.491 37.0701 113.154 58.6768 85.9153 85.9154C58.6768 113.154 37.07 145.491 22.3287 181.08C7.58728 216.668 -5.81652e-06 254.812 0 293.333L293.333 293.333V0Z",
    fill: "#DED6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M293.333 73.3333C264.443 73.3333 235.835 79.0238 209.143 90.0798C182.451 101.136 158.199 117.341 137.77 137.77C117.341 158.199 101.136 182.451 90.08 209.143C79.024 235.835 73.3335 264.443 73.3335 293.333L293.333 293.333V183.333V73.3333Z",
    fill: "#F1EEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M311.666 36.6667C345.372 36.6667 378.748 43.3056 409.888 56.2043C441.029 69.103 469.323 88.0089 493.157 111.843C516.991 135.676 535.897 163.971 548.795 195.111C561.694 226.252 568.333 259.627 568.333 293.333L311.666 293.333L311.666 36.6667Z",
    fill: "#DDFFF7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 159H216.469V249H185.531V159Z",
    fill: "#7E66E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156 219.469V188.531H246V219.469H156Z",
    fill: "#7E66E1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M246 219.425V215.036L241.568 219.469H245.957L246 219.425Z",
    fill: "#F1EEFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M216.469 248.957V244.568L212.036 249H216.425L216.469 248.957Z",
    fill: "#F1EEFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.647 249L216.469 240.179V235.79L203.259 249H207.647Z",
    fill: "#F1EEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M198.87 249L216.469 231.401V227.012L194.481 249H198.87Z",
    fill: "#F1EEFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.092 249L216.469 222.623V219.469H219.623L246 193.092V188.703L185.703 249H190.092Z",
    fill: "#F1EEFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 244.783L241.783 188.531H237.394L185.531 240.394V244.783Z",
    fill: "#F1EEFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 236.005L233.005 188.531H228.616L185.531 231.616V236.005Z",
    fill: "#F1EEFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 227.227L224.227 188.531H219.838L185.531 222.838V227.227Z",
    fill: "#F1EEFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.511 219.469L216.469 187.511V183.123L180.123 219.469H184.511Z",
    fill: "#F1EEFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.734 219.469L216.469 178.734V174.345L171.345 219.469H175.734Z",
    fill: "#F1EEFF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M166.956 219.469L216.469 169.956V165.567L162.567 219.469H166.956Z",
    fill: "#F1EEFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.178 219.469L216.469 161.178V159H214.258L185.531 187.726V188.531H184.726L156 217.258V219.469H158.178Z",
    fill: "#F1EEFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156 212.869L180.337 188.531H175.948L156 208.48V212.869Z",
    fill: "#F1EEFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M156 204.091L171.56 188.531H167.171L156 199.702V204.091Z",
    fill: "#F1EEFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156 195.313L162.782 188.531H158.393L156 190.924V195.313Z",
    fill: "#F1EEFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M185.531 161.393V165.782L192.313 159H187.924L185.531 161.393Z",
    fill: "#F1EEFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M196.702 159L185.531 170.171V174.56L201.091 159H196.702Z",
    fill: "#F1EEFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M205.48 159L185.531 178.948V183.337L209.869 159H205.48Z",
    fill: "#F1EEFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246 197.481L224.012 219.469H228.401L246 201.87V197.481Z",
    fill: "#F1EEFF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M246 206.259L232.79 219.469H237.179L246 210.647V206.259Z",
    fill: "#F1EEFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomRight);
export default __webpack_public_path__ + "static/media/bottomRight.3e1be630fd96832df81a800f11c3436b.svg";
export { ForwardRef as ReactComponent };